import React, { createContext, useState } from 'react';

const VisitorParamsContext = createContext({
  visitorParameters: {
    visitor_parameters: {
      uuid: '',
    },
    data: {},
  },
  setVisitorParameters: () => {},
});

export const VisitorParamsProvider = ({ children }) => {
  const [visitorParameters, setVisitorParameters] = useState({
    visitor_parameters: {
      uuid: '',
    },
    data: {},
  });

  return (
    <VisitorParamsContext.Provider
      value={{ visitorParameters, setVisitorParameters }}
    >
      {children}
    </VisitorParamsContext.Provider>
  );
};

export default VisitorParamsContext;
